var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-field",class:{'flex-start': !_vm.vertical, 'flex-column': _vm.vertical}},[(_vm.label)?_c('label',{staticClass:"c-field-label"},[_vm._v(_vm._s(_vm.label)+"：")]):_vm._e(),_c('div',{staticClass:"c-field-content",class:{'flex-grow': !_vm.vertical},style:({'margin-top': _vm.vertical ? '8px' : 0})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }